import React, {Fragment} from 'react';
import {Transition, Popup, Settings} from 'components';
import {modal, map, some, omit, useEvent, popups as globalPopups} from 'helpers';

export function Manager() {
  const [popups, setPopups] = globalPopups.useState();

  useEvent('popuptoggle', ({detail}) => {
    window.dispatchEvent(new CustomEvent(popups[detail.id] ? 'popupclose' : 'popupopen', {detail}));
  });

  useEvent('popupopen', ({detail}) => {
    if (!popups[detail.id]) {
      setPopups({
        ...popups,
        [detail.id]: detail
      });
    }
  });

  useEvent('popupclose', ({detail}) => {
    setPopups(state => {
      if (!state[detail.id] || state[detail.id].isClosing) {
        return state;
      }
      setTimeout(() => {
        setPopups(state => omit(state, detail.id));
        window.dispatchEvent(new CustomEvent('popupkilled', {detail}));
      }, 150);
      return {
        ...state,
        [detail.id]: {
          ...state[detail.id],
          isClosing: true
        }
      };
    });
  });

  useEvent('REDUX_UI_DISPLAY_MODAL', ({detail}) => {
    if (Settings[detail.id]) {
      modal(Settings[detail.id])();
    }
  });

  return (
    <Fragment>
      <Transition in={some(popups, {modal: true})} timeout={150}>
        { transition => <Popup.Overlay transition={transition} /> }
      </Transition>
      { map(popups, popup =>
        <Popup.Card key={popup.id} {...popup} />
      ) }
    </Fragment>
  );
}
